module.exports = __webpack_public_path__ + "img/pl.3fe3bd51.svg";